import { render, staticRenderFns } from "./ProductIndexingModal.vue?vue&type=template&id=2fe1c49e&scoped=true&"
import script from "./ProductIndexingModal.vue?vue&type=script&lang=js&"
export * from "./ProductIndexingModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductIndexingModal.vue?vue&type=style&index=0&id=2fe1c49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe1c49e",
  null
  
)

/* custom blocks */
import block0 from "./ProductIndexingModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VChip,VDialog,VForm,VImg,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle,VTextField})
